import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8975 19.3975V20.8975H7V19.3975H16.8975ZM19.3975 16.8975V7C19.3975 5.61937 18.2781 4.50013 16.8975 4.5H7C5.61929 4.5 4.5 5.61929 4.5 7V16.8975C4.50013 18.2781 5.61937 19.3975 7 19.3975V20.8975L6.79395 20.8916C4.7489 20.7878 3.10877 19.1485 3.00488 17.1035L3 16.8975V7C3 4.79086 4.79086 3 7 3H16.8975L17.1035 3.00488C19.2168 3.11224 20.8975 4.86005 20.8975 7V16.8975L20.8916 17.1035C20.7877 19.1484 19.1484 20.7877 17.1035 20.8916L16.8975 20.8975V19.3975C18.278 19.3973 19.3973 18.278 19.3975 16.8975Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 9L4 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 14L4 14",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 20L12 9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgTableView;
